import type { IntlShape } from 'react-intl'
import { getMaxGuestCount } from 'lib/offer/occupancyUtils'

export function getVillaCapacityText(intl: IntlShape, offer: App.VillaOffer | App.VillaOfferSummary) {
  if (!offer.lowestPricePackage) return ''

  const roomRate = offer.lowestPricePackage.roomRate
  if (!roomRate) {
    return ''
  }

  const roomType = offer.lowestPricePackage.roomType
  if (!roomType) {
    return ''
  }

  const capacity = getMaxGuestCount(roomRate.capacities)
  if (!capacity) return ''

  const hasBedrooms = !!roomType.numberOfBedrooms
  const hasBathrooms = !!roomType.numberOfBathrooms
  const guestCountLabel = intl.formatMessage(
    {
      id: 'R3019BzeZYCjSRIYIlGe',
      defaultMessage: '{guestCount, plural, one {# guest} other {# guests}}',
      description: 'Guest count label shown in the villa capacity summary',
    },
    { guestCount: capacity },
  )
  const bedroomCountLabel = intl.formatMessage(
    {
      id: 'Dm_CF9Sswqlzy_KHQiT-',
      defaultMessage: '{bedroomCount, plural, one {# bedroom} other {# bedrooms}}',
      description: 'Bedroom count label shown in the villa capacity summary',
    },
    { bedroomCount: roomType.numberOfBedrooms },
  )
  const bathroomCountLabel = intl.formatMessage(
    {
      id: 'nlGNE-akGqF7kc3Iaqf7',
      defaultMessage: '{bathroomCount, plural, one {# bathroom} other {# bathrooms}}',
      description: 'Bathroom count label shown in the villa capacity summary',
    },
    { bathroomCount: roomType.numberOfBathrooms },
  )

  if (hasBedrooms && hasBathrooms) {
    return intl.formatMessage(
      {
        id: '0Z3jHIzfiAbwyB5XT3FB',
        defaultMessage: 'Up to {guestCountLabel} · {bedroomCountLabel} · {bathroomCountLabel}',
        description: 'Villa capacity summary with guests, bedrooms, and bathrooms',
      },
      { guestCountLabel, bedroomCountLabel, bathroomCountLabel },
    )
  }

  if (hasBedrooms) {
    return intl.formatMessage(
      {
        id: 'GF8VRYgXNVKVXcip2nkv',
        defaultMessage: 'Up to {guestCountLabel} · {bedroomCountLabel}',
        description: 'Villa capacity summary with guests and bedrooms in the villas section',
      },
      { guestCountLabel, bedroomCountLabel },
    )
  }

  if (hasBathrooms) {
    return intl.formatMessage(
      {
        id: 'uV8AvC22sdke0JphRf29',
        defaultMessage: 'Up to {guestCountLabel} · {bathroomCountLabel}',
        description: 'Villa capacity summary with guests and bathrooms in the villas section',
      },
      { guestCountLabel, bathroomCountLabel },
    )
  }

  return intl.formatMessage(
    {
      id: '-RmGt1ZBw6xjkRPBABca',
      defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}}',
      description: 'Villa capacity summary with guests only on the villa or rental property page',
    },
    { guestCount: capacity },
  )
}
